import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { EventPageType } from '@graphql/generated-base';
import { CUSTOM_PAGE_PATH } from '@apps/guest/routes/GuestSite/GuestSite.constants';
import { isMigratedCustomPageSlug } from '@shared/utils/migratedCustomPages';

export const getSlugFromPathname = (pathname: string) => {
  const isCustomPagePath = pathname.split('/')[2] === CUSTOM_PAGE_PATH;
  const pagePath = isCustomPagePath ? pathname.split('/')[3] : pathname.split('/')[2];
  return { pagePath, isCustomPagePath };
};

export const getPageInfo = (pages: ReadonlyArray<EventPageFragment>, pathname: string) => {
  const { pagePath, isCustomPagePath } = getSlugFromPathname(pathname);
  const pageFound = pages.find(p => p.pageSlug === pagePath);

  // Migrated custom pages (e.g. story) so telemetry identifies the page type correctly for
  // routes like /${eventHandle}/story.
  const isMigratedCustomPage = isMigratedCustomPageSlug(pageFound?.pageSlug) && pageFound?.type === EventPageType.custom;

  const isCustomPage = isCustomPagePath || isMigratedCustomPage;
  return { pageSlug: isCustomPage ? EventPageType.custom : pageFound?.pageSlug, pageFound };
};
